import {
  SET_APPLICATION_NAME,
  SET_APP_DATA,
  SET_HOSPITAL_ID,
  SET_MSAL_CONFIG_DATA
} from '.';
import {encrypt} from '../../utils/LocalStorage';
import {
  SetAppDataAction,
  SetAppDataParams,
  SetApplicationNameAction,
  SetApplicationNameParams,
  SetHospitalIdAction,
  SetHospitalIDParams,
  SetMSALConfigAction,
  SetMSALConfigParams
} from '../mappers/AppTypesMapper';

export const setAppData = (
  dispatch: (action: SetAppDataAction) => void,
  param: SetAppDataParams
): void => {
  dispatch({
    type: SET_APP_DATA,
    payload: param
  });
};

export const setApplicationName = (
  dispatch: (action: SetApplicationNameAction) => void,
  param: SetApplicationNameParams
): void => {
  localStorage.setItem('applicationName', param.applicationName ?? '');
  dispatch({
    type: SET_APPLICATION_NAME,
    payload: {applicationName: param.applicationName}
  });
};
export const setHospitalId = (
  dispatch: (action: SetHospitalIdAction) => void,
  param: SetHospitalIDParams
): void => {
  localStorage.setItem('hospitalId', param.hospitalId ?? '');
  dispatch({
    type: SET_HOSPITAL_ID,
    payload: {hospitalId: param.hospitalId}
  });
};

export const setMsalConfigData = (
  dispatch: (payload: SetMSALConfigAction) => void,
  param: SetMSALConfigParams
): void => {
  localStorage.setItem(
    'authConfig',
    encrypt(JSON.stringify(param?.authConfig))
  );
  dispatch({
    type: SET_MSAL_CONFIG_DATA,
    payload: {authConfig: param?.authConfig}
  });
};
